import { platformAdminIdentityCustomFields } from "./platform-admin-identity-custom-fields";
import { platformAdminIdentityOrganizationTree } from "./platform-admin-identity-organization-tree";
import { platformAdminIdentityUserWorkflows } from "./platform-admin-identity-user-workflows";
import { platformAdminIdentityValues } from "./platform-admin-identity-values";
import { platformAdminIdentityWorkflows } from "./platform-admin-identity-workflows";
export const platformAdminIdentity = {
  duration1Day: "1日",
  duration1Week: "1週間",
  duration1Month: "1か月",
  duration1Year: "1年",

  title: "統合認証",
  subtitle: "プラットフォームの ID 主データ、ID 接続アプリ、プラットフォームロールの現在状態です。",
  directRead:
    "このページは sso-center の ID 主データを直接参照し、書き込みも統合認証センターへ直接反映します。",
  indirectRead:
    "現在のセッションは統合認証ログインではありません。このページは連携状態のみ表示し、統合認証ログイン後に主データを直接参照・管理できます。",
  loadFailed: "統合認証データの取得に失敗しました",
  summaryMode: "認証モード：{value}",
  summarySso: "SSO 状態：{value}",
  summaryUsers: "有効ユーザー：{count}",
  summaryApps: "ID 接続アプリ：{count}",
  summaryTenants: "テナント：{count}",
  summaryOrgs: "組織：{count}",
  summaryRoles: "プラットフォームロール：{count}",
  authCardTitle: "認証モード",
  authModeCurrent: "現在の auth_mode",
  ssoTarget: "SSO 接続先",
  identityDomain: "統合認証ドメイン",
  consoleCardTitle: "身份コンソール情報",
  links: {
    portal: "ポータル",
    platformAdmin: "プラットフォーム管理",
  },
  menu: {
    identity: "身份ガバナンス",
    userCustomFields: "ユーザーカスタム項目",
  },
  common: {
    pageNotFound: "ページが見つかりません。",
    backToIdentity: "身份センターへ戻る",
  },
  login: {
    pageTitle: "{platformName} · 統合認証",
    summary:
      "プラットフォーム管理系ワークスペースは、まず統合認証の現在セッションを引き継いでから対象コントロールプレーンへ入ります。",
    maintenanceNotice:
      "統合認証コンソールは現在メンテナンス中です。ガバナンス機能の一部が一時的に利用できない場合があります。",
    noAccess: "現在の統合認証には身份コンソールへのアクセス権がありません。",
  },
  dashboard: {
    title: "身份概覧",
    subtitle:
      "統一身份ガバナンスサイトのホームとして、アプリ接続、ユーザー、テナント、組織、ロール、権限の管理入口をまとめて表示します。",
    cards: {
      applications: "アプリ接続ガバナンス",
      users: "プラットフォームユーザー治理",
      roles: "ロール・権限ガバナンス",
    },
  },
  overview: {
    kpiActiveUsers: "有効ユーザー",
    kpiApplications: "接続アプリ",
    kpiTenants: "テナント",
    kpiOrganizations: "組織",
    kpiRoles: "プラットフォームロール",
    kpiCriticalRisks: "重大リスク",
    accessStatusTitle: "接続・認証状態",
    masterDataTitle: "身份主データ規模",
    riskTitle: "ガバナンスリスク",
    metricSsoStatus: "SSO 状態",
    metricBlockedApplications: "ブロックされたアプリ",
    metricDegradedApplications: "劣化アプリ",
    metricCredentialIssues: "資格情報異常アプリ",
    recentEventsSubtitle: "直近 8 件の身份ガバナンスイベント",
  },
  sections: {
    applications: {
      title: "ID 接続アプリ",
      subtitle:
        "統一身份に登録されたアプリカタログ、付与ルール、アプリロールマッピング、接続資格情報を管理します。",
    },
    tenants: {
      title: "テナント",
      subtitle: "統一身份のテナント主データを管理し、将来のマルチテナント境界を保持します。",
    },
    organizations: {
      title: "組織",
      subtitle: "組織ツリー、ノード所属メンバー、組織スコープを一元管理します。",
    },
    users: {
      title: "プラットフォームユーザー",
      subtitle:
        "基礎プロフィール、プラットフォームロール、アプリロールマッピング、アプリ文脈を管理します。",
    },
    userCustomFields: {
      title: "ユーザーカスタム項目",
      subtitle:
        "統一身份のプロフィール拡張に用いるプラットフォームユーザー向け拡張項目定義を管理します。",
    },
    roles: {
      title: "プラットフォームロール",
      subtitle: "プラットフォームロール辞書と既定のガバナンス境界を管理します。",
    },
    permissions: {
      title: "権限点",
      subtitle:
        "権限点辞書と権限バインドを管理し、プラットフォーム統治とアプリ消費の共通権限主データとします。",
    },
    events: {
      title: "ID 監査",
      subtitle: "誰がいつどの ID オブジェクトにどのガバナンス操作を行ったかを追跡します。",
    },
    loginRecords: {
      title: "ログイン記録",
      subtitle: "実際のログイン試行、結果、接続元 IP、取得したクライアント環境情報を確認します。",
    },
  },
  objects: {
    application: "ID 接続アプリ",
    organizationUnit: "組織ノード",
    grant: "利用ルール",
    roleMapping: "ロールマッピング",
    permissionBinding: "権限バインド",
    tenant: "テナント",
    user: "ユーザー",
    role: "プラットフォームロール",
    permission: "権限点",
    userCustomField: "ユーザーカスタム項目",
  },
  roleLabels: {
    platform_admin: "プラットフォーム管理者",
    intelligence_admin: "インテリジェンス管理者",
    identity_admin: "身份管理者",
    asset_admin: "アセット管理者",
    asset_editor: "アセット編集者",
    execution_admin: "実行管理者",
    environment_admin: "環境管理者",
    environment_designer: "環境設計者",
    tactics_techniques_admin: "戦術技法センター管理者",
    capability_graph_admin: "能力グラフ管理者",
    vulnerability_library_admin: "脆弱性情報ライブラリ管理者",
    business_reference_admin: "業務参照センター管理者",
    traffic_library_admin: "トラフィックライブラリ管理者",
    platform_operator: "プラットフォーム運用",
    auditor: "監査担当",
    harbor_admin: "Harbor 管理者",
    redblue_admin: "RedBlue 管理者",
    redblue_activity_manager: "RedBlue 活動管理者",
    admin: "管理者",
    user: "ユーザー",
    owner: "責任者",
    tester: "テスター",
    student: "受講者",
    candidate: "受験者",
    question_editor: "問題編集者",
    exam_manager: "試験管理者",
    reviewer: "採点担当",
    proctor: "監督者",
  },
  fallbackPermissions: {
    consoleReadName: "身份コンソールを表示",
    consoleReadDescription: "統一身份ガバナンスコンソールの概覧と現在状態を表示します。",
    identityReadName: "身份センターを表示",
    identityReadDescription: "統一身份、アプリ、テナント、組織、ユーザー文脈を表示します。",
    identityManageName: "身份センターを管理",
    identityManageDescription:
      "プラットフォームロール、権限点、バインド、テナント、組織、アプリ接続ルールを管理します。",
    assetReadName: "アセットセンターを表示",
    assetReadDescription: "アセット、オブジェクト空間、参照関係を表示します。",
    assetManageName: "アセットセンターを管理",
    assetManageDescription: "アセット、アップロード方針、オブジェクト空間付与を管理します。",
    executionReadName: "実行基盤を表示",
    executionReadDescription: "インスタンス、タスク、イメージ実行状態を表示します。",
    executionManageName: "実行基盤を管理",
    executionManageDescription: "インスタンス、実行資源、実行タスクを管理します。",
    auditReadName: "プラットフォーム監査を表示",
    auditReadDescription: "ログインログ、操作ログ、プラットフォーム監査記録を表示します。",
  },
  roleModel: "プラットフォームロールモデル",
  componentTitle: "統合認証コンポーネント",
  openSso: "SSO を開く",
  footerNote:
    "このページは sso-center の ID 接続アプリ、テナント、組織、プラットフォームロール辞書、権限点、ロールバインド、権限バインド、アプリロールマッピング、および ID 統治イベントを直接管理します。",
  tabs: {
    applications: "ID 接続アプリ ({count})",
    tenants: "テナント ({count})",
    organizations: "組織 ({count})",
    users: "プラットフォームユーザー ({count})",
    userCustomFields: "ユーザーカスタム項目 ({count})",
    roles: "プラットフォームロール ({count})",
    permissions: "権限点 ({count})",
    events: "ID 監査",
    loginRecords: "ログイン記録",
  },
  tables: {
    applications: "ID 接続アプリ",
    tenants: "テナント",
    organizations: "組織",
    roleDict: "プラットフォームロール辞書",
    permissionDict: "権限点辞書",
    applicationGrantRules: "アプリ利用ルール",
    applicationRoleMappings: "アプリロールマッピング",
    credentials: "アクセス資格情報",
    applicationAccess: "アプリアクセス",
    businessRoleMatches: "ロールマッピング一致",
    permissionMatches: "権限一致結果",
    permissionBindings: "権限バインド",
  },
  columns: {
    component: "コンポーネント",
    domain: "ドメイン",
    latency: "遅延",
    note: "説明",
    application: "アプリ",
    portalDescription: "ポータル説明",
    applicationKey: "関連サービスコード",
    entry: "レジストリ入口 URL",
    sortOrder: "並び順",
    grantRules: "利用ルール",
    roleKey: "ロールキー",
    displayName: "表示名",
    scope: "スコープ",
    systemManaged: "システム管理",
    membershipCount: "メンバー割当",
    applicationGrantCount: "利用ルール数",
    mappingCount: "マッピング",
    permissionKey: "権限キー",
    applicationOwner: "所属アプリ",
    resourceAction: "リソース / 操作",
    bindingCount: "バインド数",
    tenant: "テナント",
    tenantKey: "テナントキー",
    organization: "組織",
    organizationKey: "組織キー",
    tenantOwner: "所属テナント",
    account: "ユーザー名",
    fullName: "ニックネーム",
    onlineStatus: "オンライン状態",
    mustChangePassword: "パスワード変更要",
    failedLoginAttempts: "失敗回数",
    lockedUntil: "ロック解除時刻",
    lastLoginAt: "最終ログイン",
    businessRole: "業務ロール",
    platformRole: "プラットフォームロール",
    applicationRoles: "アプリロール",
    organizationMemberships: "組織所属",
    source: "ソース",
    accessible: "アクセス可",
    matchReason: "一致理由",
    matchedMapping: "一致マッピング",
    permission: "権限点",
    matchedBinding: "一致バインド",
    eventType: "イベント分類",
    action: "操作アクション",
    resourceType: "対象種別",
    resourceIdentifier: "監査対象",
    operator: "実行者",
    time: "発生時刻",
    grantSubject: "利用主体",
    subjectValue: "主体値",
    accessLevel: "利用レベル",
    subjectType: "主体種別",
    priority: "優先度",
    secretHint: "Secret 指紋",
    expiresAt: "有効期限",
    rotatedAt: "ローテーション時刻",
    targetApplication: "対象アプリ",
    objectValue: "主体値",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    tokenEndpointAuthMethod: "クライアント認証方式",
    payloadSummary: "証跡概要",
    payloadJson: "原始証跡 JSON",
    eventId: "監査 ID",
    recordUpdatedAt: "記録更新時刻",
    loginRecordId: "ログイン記録 ID",
    loginTime: "ログイン時刻",
    loginStatus: "ログイン結果",
    authFlow: "認証フロー",
    failureReason: "失敗理由",
    clientIp: "クライアント IP",
    userAgent: "UA",
    browserLanguage: "ブラウザー言語",
    screenResolution: "画面解像度",
    terminalType: "端末種別",
    os: "OS",
    browser: "ブラウザー",
  },
  values: platformAdminIdentityValues,
  actions: {
    ...platformAdminIdentityWorkflows.actions,
    ...platformAdminIdentityUserWorkflows.actions,
  },
  drawers: {
    ...platformAdminIdentityWorkflows.drawers,
    ...platformAdminIdentityUserWorkflows.drawers,
  },
  customFields: platformAdminIdentityCustomFields,
  alerts: {
    ...platformAdminIdentityWorkflows.alerts,
    ...platformAdminIdentityUserWorkflows.alerts,
  },
  confirms: {
    ...platformAdminIdentityWorkflows.confirms,
    ...platformAdminIdentityUserWorkflows.confirms,
  },
  messages: {
    ...platformAdminIdentityWorkflows.messages,
    ...platformAdminIdentityUserWorkflows.messages,
  },
  organizationTree: platformAdminIdentityOrganizationTree,
  forms: {
    ...platformAdminIdentityWorkflows.forms,
    ...platformAdminIdentityUserWorkflows.forms,
  },
};
